function addAnimationClass (element, className, delay) {
    setTimeout (() => {
        element.classList.add(className)
    }, delay)
}

function addFlipCardAnimationClass (element, callback) {
    setTimeout (() => {
        element.classList.toggle('mtt-athena-flip-card--flip')
        callback()
    }, 4000)
}

function flipLeftCard () {
    const CARD = document.querySelector('.mtt-athena-flip-card--left')
    addFlipCardAnimationClass(CARD, flipLeftCard)
}

function flipRightCard () {
    const CARD = document.querySelector('.mtt-athena-flip-card--right')
    addFlipCardAnimationClass(CARD, flipRightCard)
}

export default function AthenaCoverAnimations () {
    const ATHENA_MODEL = document.querySelector('.mtt-athena-model')

    if(!ATHENA_MODEL) return

    if (window.innerWidth > 500) {
        addAnimationClass(ATHENA_MODEL, 'mtt-athena-model--step1', 1000)
        addAnimationClass(ATHENA_MODEL, 'mtt-athena-model--step2', 3000)
        addAnimationClass(ATHENA_MODEL, 'mtt-athena-model--step3', 5000)
    } else {
        ATHENA_MODEL.classList.add('mtt-athena-model--step1')
        ATHENA_MODEL.classList.add('mtt-athena-model--step2')
        ATHENA_MODEL.classList.add('mtt-athena-model--step3')
    }


    setTimeout(() => {
        flipLeftCard()
    }, 3000)

    setTimeout(() => {
        flipRightCard()
    }, 3100)
}
